'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _Footer = require('./Footer.scss');

var _Footer2 = _interopRequireDefault(_Footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  Footer: {
    displayName: 'Footer'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Pachantiew/Footer.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var Footer = _wrapComponent('Footer')((_dec = (0, _reactCssModules2.default)(_Footer2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Footer, _Component);

  function Footer() {
    (0, _classCallCheck3.default)(this, Footer);
    return (0, _possibleConstructorReturn3.default)(this, (Footer.__proto__ || (0, _getPrototypeOf2.default)(Footer)).apply(this, arguments));
  }

  (0, _createClass3.default)(Footer, [{
    key: 'render',
    value: function render() {
      var fbImg = require('theme/images/social/facebook-c.png');
      var lineImg = require('./line.png');
      return _react3.default.createElement(
        'footer',
        { styleName: 'footer' },
        _react3.default.createElement(
          'div',
          { styleName: 'footer-container' },
          _react3.default.createElement(
            'div',
            { styleName: 'social-container' },
            _react3.default.createElement(
              'a',
              { href: 'https://www.facebook.com/pachantiew', target: '_blank' },
              _react3.default.createElement('img', { src: fbImg, alt: 'facebook' })
            ),
            _react3.default.createElement(
              'a',
              { href: 'https://line.me/R/ti/p/%40rol5201y', target: '_blank' },
              _react3.default.createElement('img', { src: lineImg, alt: 'line' })
            )
          ),
          _react3.default.createElement(
            'p',
            { styleName: 'footer-p' },
            '\u0E1A\u0E23\u0E34\u0E29\u0E31\u0E17 \u0E1E\u0E32\u0E09\u0E31\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E27 \u0E08\u0E33\u0E01\u0E31\u0E14'
          )
        )
      );
    }
  }]);
  return Footer;
}(_react2.Component)) || _class));

exports.default = Footer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/Footer.js
// module id = 671
// module chunks = 47